
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wir recherchieren und schreiben über die verschiedensten Themen, vom Chaos auf der Baustelle in Wallisellen über neue Gemüsesorten, die wegen des Klimawandels plötzlich auch im Furttal gedeihen, bis zum Mieterprotest an der Hellmutstrasse in der Stadt Zürich. Doch wir sehen und hören nicht alles.`}</p>
    <p>{`Hier kommen Sie ins Spiel: `}<strong parentName="p">{`Welche Themen haben wir Ihrer Meinung nach übersehen?`}</strong>{` Sie können uns jederzeit per Mail erreichen: `}<a parentName="p" {...{
        "href": "mailto:zuerich@tages-anzeiger.ch?subject=%5BLeserhinweis%5D"
      }}>{`zuerich@tages-anzeiger.ch`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;